import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from '@/util/react-router-dom';
import { initializeAppInsights } from '@/services/app-insights-service';
import { App } from './app';
import './styles/index.css';

initializeAppInsights();

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
